import { render, staticRenderFns } from "./Item-simple.vue?vue&type=template&id=40cb4b64&scoped=true&lang=pug"
import script from "./Item-simple.vue?vue&type=script&lang=js"
export * from "./Item-simple.vue?vue&type=script&lang=js"
import style0 from "./Item-simple.vue?vue&type=style&index=0&id=40cb4b64&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40cb4b64",
  null
  
)

export default component.exports